const makeOption = (from, to, type = 'default') => {
  if (type === 'default') {
    return {
      type,
      from: {
        href: from,
      },
      to: {
        href: to,
      },
    };
  }

  if (type === 'phone') {
    return {
      type,
      from: {
        href: `tel:${from}`,
        innerText: from,
      },
      to: {
        href: `tel:${to}`,
        innerText: to,
      },
    };
  }

  throw new Error('Invalid link attribution config');
};

const makeConfig = (param, options) => {
  // const links = options.reduce((acc, option) => {
  //   acc.set(option.from.href, option);
  //   return acc;
  // }, new Map());

  return {
    param,
    options,
    //links,
  };
};

const build = (config) => {
  return config.reduce((acc, entry) => {
    acc.set(entry.param, entry);
    return acc;
  }, new Map());
};

const config = build([
  makeConfig('fbclid', [
    makeOption(
      'https://intelliapp.driverapponline.com/c/ltitruckingservices?r=website',
      'https://intelliapp.driverapponline.com/c/ltitruckingservices?r=facebook'
    ),
    makeOption('888-897-2776', '888-818-3890', 'phone'),
  ]),
]);

const getQueryParams = () => {
  if (window.location.search.length === 0) {
    return null;
  }

  return window.location.search
    .substr(1)
    .split('&')
    .map((param) => param.split('=')[0]);
};

const run = () => {
  const params = getQueryParams();

  if (params === null) {
    return;
  }

  const paramKey = params.find((key) => config.has(key));
  if (!paramKey) {
    return;
  }

  const option = config.get(paramKey);

  if (!option) {
    return;
  }

  option.options.forEach(({ from, to }) => {
    const needle = `[href='${from.href}']`;
    const nodeList = document.querySelectorAll(needle);

    nodeList.forEach((el) => {
      el.href = to.href;
      if (to.innerText) {
        el.innerText = to.innerText;
      }
    });
  });
};

window.addEventListener('load', () => {
  run();
});
